module.exports = __webpack_public_path__ + "static/img/sec1-cont02@t.f40e264.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem-history/sec1-cont02@t.png
// module id = v5es
// module chunks = 0